// src/pages/AttendanceReportPage.js

import React, { useState } from 'react';
import {
  Container,
  Typography,
  TextField,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Alert,
  Box,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAttendanceReport } from '../actions/attendanceReportActions';

const AttendanceReportPage = () => {
  const dispatch = useDispatch();
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [loading, setLoading] = useState(false);
  const errorMessage = useSelector((state) => state.attendanceReport.error);
  const reportData = useSelector((state) => state.attendanceReport.report);

  const handleFetchReport = async () => {
    if (!startDate || !endDate) {
      return;
    }
    setLoading(true);
    try {
      await dispatch(fetchAttendanceReport(startDate, endDate));
    } catch (error) {
      // Error is handled by reducer
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container sx={{ py: 4 }}>
      <Typography variant="h4" gutterBottom>
        Raport de Prezență
      </Typography>
      <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap', mb: 2 }}>
        <TextField
          label="De la"
          type="date"
          InputLabelProps={{ shrink: true }}
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
        />
        <TextField
          label="Până la"
          type="date"
          InputLabelProps={{ shrink: true }}
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
        />
        <Button
          variant="contained"
          color="primary"
          onClick={handleFetchReport}
          disabled={loading}
        >
          {loading ? 'Se încarcă...' : 'Generează Raportul'}
        </Button>
      </Box>
      {errorMessage && <Alert severity="error" sx={{ mb: 2 }}>{errorMessage}</Alert>}
      {reportData && reportData.length > 0 && (
        <>
          <Typography variant="h6" gutterBottom>
            Rezultate:
          </Typography>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Nume Copil</TableCell>
                <TableCell>Total Zile</TableCell>
                <TableCell>Zile Prezente</TableCell>
                <TableCell>Zile Absențe</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {reportData.map((row) => (
                <TableRow key={row.child_id}>
                  <TableCell>{row.name}</TableCell>
                  <TableCell>{row.total_days}</TableCell>
                  <TableCell>{row.present_days}</TableCell>
                  <TableCell>{row.absent_days}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </>
      )}
    </Container>
  );
};

export default AttendanceReportPage;
